export class AuthenticationServerValidationError {
  constructor(
    readonly message: string,
    readonly code: string,
  ) {}
}
